// extracted by mini-css-extract-plugin
export default {"container":"Library_container__abow3","image_container":"Library_image_container__+r+2N","image":"Library_image__kWPbv","label":"Library_label__uqzfg"};